/**
 * Jeff, Oct 1 — a Team Budget slot invitation (type 15): a slot on a team, held for
 * the invitee by the team's rep. It is taken by REGISTERING for the team through
 * the web wizard (registration is web-only), never by accepting the invitation —
 * the server refuses a plain accept for this type.
 */

/** The invitation type's id, as the API sends it. */
export const TEAM_BUDGET_SLOT_INVITATION_TYPE_ID = '15'

/** Where the invitee registers, and what for (`registration` on the invitation). */
export interface TeamBudgetSlotRegistration {
  /** The web wizard, opened on the team and bound to this invitation; null when it can't be built. */
  url: string | null
  schedule_id: string | null
  division_id: string | null
  team_id: string | null
  competition_name?: string | null
  division_name?: string | null
}

/** The invitation fields read here. */
export interface TeamBudgetSlotInvitationLike {
  type?: { id?: string | number | null } | null
  registration?: TeamBudgetSlotRegistration | null
}

export const isTeamBudgetSlotInvitation = (
  invite: TeamBudgetSlotInvitationLike | null | undefined
): boolean =>
  invite?.type?.id != null &&
  String(invite.type.id) === TEAM_BUDGET_SLOT_INVITATION_TYPE_ID

/** The wizard link the invitee registers through, or null when there is none to follow. */
export const teamBudgetSlotRegistrationUrl = (
  invite: TeamBudgetSlotInvitationLike | null | undefined
): string | null =>
  isTeamBudgetSlotInvitation(invite) ? invite?.registration?.url || null : null
